<template>
  <a
    v-if="url"
    :class="['button-ghost', { black: props.isBlack }]"
    :style="styles"
    :href="url"
    target="_blank"
    @click="pushEvent"
  >
    <icon
      v-if="iconBefore"
      class="button-icon"
      :data="iconBefore"
      color="var(--icon-color)"
      width="24"
      height="24"
    />
    {{ label }}
    <icon
      v-if="iconAfter"
      class="button-icon"
      :data="iconAfter"
      color="var(--icon-color)"
      width="24"
      height="24"
    />
  </a>

  <button
    v-else
    :class="['button-ghost', { black: props.isBlack }]"
    :style="style"
    @click="$emit('onClick')"
  >
    <icon
      v-if="iconBefore"
      class="button-icon"
      :data="iconBefore"
      color="var(--icon-color)"
      width="24"
      height="24"
    />
    {{ label }}
    <icon
      v-if="iconAfter"
      class="button-icon"
      :data="iconAfter"
      color="var(--icon-color)"
      width="24"
      height="24"
    />
  </button>
</template>

<script setup>
import { pushData } from "@/utilities/analytics-functions.js";

const props = defineProps({
  label: String,
  url: String,
  isBlack: Boolean,
  iconBefore: Object || undefined,
  iconAfter: Object || undefined,
  styles: Object,
});

function pushEvent() {
  if (props.url && props.url.includes(".pdf")) {
    pushData({
      event: "fileDownload",
      eventType: "pdf",
      componentType: props.componentType,
      componentTitle: props.componentTitle,
      componentLink: props.url,
      componentLinkText: props.label,
    });
  }
}
</script>

<style lang="scss" scoped>
.button-ghost {
  @include overlay-m;

  max-height: calc(toRem(18) + calc(0.75rem * 2));

  padding: 1rem;
  color: var(--color-white);
  width: fit-content;
  // transition: border 0.3s, color 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;

  --icon-color: var(--color-white);

  // svg {
  //   transition: stroke 0.3s, fill 0.3s;

  //   path {
  //     transition: stroke 0.3s, fill 0.3s;
  //   }
  // }

  &.black {
    color: var(--color-black);
    --icon-color: var(--color-black);
  }

  &:hover:not(:disabled) {
    --color-hover: var(--brand-stronger);

    &.black {
      --color-hover: var(--color-black-hover);
    }

    --icon-color: var(--brand-stronger);
    color: var(--brand-stronger);
  }

  .mobile & {
    padding: 1rem 1.5rem;
  }
}
</style>
